/* because some problem in registrate flow and composition usage, we should do it */
import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);
